module.exports = __webpack_public_path__ + "static/media/5.0dc4738e.avif";